import { Routes } from '../stores/instant-pay.store';
import type { CXRootStore } from '../../stores/cx-root.store';
import { getForterToken } from '../../../../utils/client-experience.utils';
import { IInstantPayInvoice } from '../../../../types/instant-pay.types';

export class InstantPayController {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async loadPaymentData(hbToken: string) {
        try {
            const data =
                await this.rootStore.giftCardCXApiService.fetchPaymentData(
                    hbToken
                );

            this.rootStore.instantPayStore.updatePaymentData(
                this.handleLoadData(data)
            );
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            this.rootStore.instantPayStore.setActiveRoute(Routes.LoadError);
        }
    }

    // TODO: move this to GiftCardCXApiService
    private handleLoadData(data) {
        if (!data) {
            return null;
        }

        if (data.invalid_reason) {
            return data;
        }

        const { pay_data } = data;

        return {
            client: pay_data.client,
            vendor: pay_data.vendor,
            proposal: {
                ...pay_data.proposal,
                amount: pay_data.final_price_after_discount
            },
            style_container: pay_data.style_container
        };
    }

    async reportPaymentToBE(card: any, hbToken: string) {
        const { instantPayStore } = this.rootStore;
        instantPayStore.setPaymentError(null);

        if (!card) {
            // eslint-disable-next-line no-console
            console.error('reportPaymentToBE: no card given');
        }

        const response = await this.rootStore.giftCardCXApiService.pay(
            getForterToken(),
            hbToken,
            card
        );

        if ('error' in response) {
            instantPayStore.setPaymentError(response.error);
            return;
        }

        if (response.invalid_reason) {
            instantPayStore.updatePaymentData(response);
            return;
        }

        instantPayStore.setInvoice(response as IInstantPayInvoice);
        instantPayStore.setActiveRoute(Routes.ThankYou);
    }
}
